module.exports = __webpack_public_path__ + "static/media/aa.ae777547.jpeg";